<template>
  <!-- 一对一咨询 -->
  <div id="case">

    <section><casebanner/> </section>

    <section><caseprocess1/> </section>
    
    <section class="casetjhflaw w_100"><casetjhfbdls/> </section>

    <section><casezxlbhf/> </section>


  </div>
</template>

<script>

import casebanner from "./child/casebanner";//一对一咨询banner
import caseprocess1 from "./child/caseprocess1";//一对一咨询流程
import casetjhfbdls from "./child/casetjhfbdls";//合肥推荐律师
import casezxlbhf from "./child/casezxlbhf";//咨询列表及回复，杂项


export default {
  name: "case",
  components: {


    // 私
    casebanner,
    caseprocess1,
    casetjhfbdls,
    casezxlbhf

  },
};
</script>

<style lang="scss" scoped>
#case {
  background-color: #fff;
  .casetjhflaw{
    background-color: #F8F8F8;
  }
}
</style>
